import React from 'react';
import PropTypes from 'prop-types';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '@/pages/dashboard-year/MetricLoader';
import DeltaMetric from '@/pages/dashboard-year/DeltaMetric';
import useCompletedEducatorProjectEvaluations from '@/features/dashboard-eval/hooks/useCompletedEducatorProjectEvaluations';
import useEducatorProjectEvaluations from '@/features/dashboard-eval/hooks/useEducatorProjectEvaluations';
import moment from 'moment-timezone';
import ComparisonMetric from '@/pages/dashboard-year/ComparisonMetric';

CompositeEducatorProjectEvaluations.propTypes = {
  state: PropTypes.string,
  network: PropTypes.shape({ id: PropTypes.number }),
  schoolStart: PropTypes.string,
  schoolEnd: PropTypes.string,
  titleOnly: PropTypes.bool,
  showTotals: PropTypes.bool
};

export default function CompositeEducatorProjectEvaluations(props) {
  const { state, network, schoolStart, schoolEnd, titleOnly, showTotals = true } = props;

  const previousSchoolStart = titleOnly ? undefined : moment(schoolStart).subtract(1, 'year').toISOString();

  const totalEvaluations = useEducatorProjectEvaluations({ state, network, schoolStart: undefined, schoolEnd });
  const previousEvaluations = useEducatorProjectEvaluations({ state, network, schoolStart: previousSchoolStart, schoolEnd: schoolStart });
  const newEvaluations = useEducatorProjectEvaluations({ state, network, schoolStart, schoolEnd });

  const totalEvaluationsCompleted = useCompletedEducatorProjectEvaluations({ state, network, schoolStart: undefined, schoolEnd });
  const previousEvaluationsCompleted = useCompletedEducatorProjectEvaluations({ state, network, schoolStart: previousSchoolStart, schoolEnd: schoolStart });
  const newEvaluationsCompleted = useCompletedEducatorProjectEvaluations({ state, network, schoolStart, schoolEnd });

  if (
    totalEvaluations.state === PayloadStates.FETCHING ||
    previousEvaluations.state === PayloadStates.FETCHING ||
    newEvaluations.state === PayloadStates.FETCHING ||
    totalEvaluationsCompleted.state === PayloadStates.FETCHING ||
    previousEvaluationsCompleted.state === PayloadStates.FETCHING ||
    newEvaluationsCompleted.state === PayloadStates.FETCHING
  ) {
    return (
      <>
        {showTotals && (
          <>
            <MetricLoader
              name="Total educator project evaluations sent"
            />
            <MetricLoader
              name="Total educator project evaluations completed"
            />
          </>
        )}
        {!titleOnly && (
          <>
            <MetricLoader
              name="Educator project evaluations sent"
            />
            <MetricLoader
              name="Educator project evaluations completed"
            />
          </>
        )}
      </>
    );
  }

  return (
    <>
      {showTotals && (
        <>
          <DeltaMetric
            name="Total educator project evaluations sent"
            value={totalEvaluations.meta.totalCount}
            delta={newEvaluations.meta.totalCount}
            titleOnly={titleOnly}
          />
          <DeltaMetric
            name="Total educator project evaluations completed"
            value={totalEvaluationsCompleted.meta.totalCount}
            delta={newEvaluationsCompleted.meta.totalCount}
            titleOnly={titleOnly}
          />
        </>
      )}
      {!titleOnly && (
        <>
          <ComparisonMetric
            name="Educator project evaluations sent"
            value={newEvaluations.meta.totalCount}
            previousValue={previousEvaluations.meta.totalCount}
            titleOnly={titleOnly}
          />
          <ComparisonMetric
            name="Educator project evaluations completed"
            value={newEvaluationsCompleted.meta.totalCount}
            previousValue={previousEvaluationsCompleted.meta.totalCount}
            titleOnly={titleOnly}
          />
        </>
      )}
    </>
  );
}
